import { httpClient } from '@/infra/protocols/http';

export async function deletePodcast(
  params: DeletePodcastService.Params,
): Promise<DeletePodcastService.Response> {
  const response = await httpClient.delete<{ mensagem: string }>(
    `/v1/projetos/${params.projectId}/podcasts/${params.podcastId}`,
  );
  return { message: response.mensagem };
}

export namespace DeletePodcastService {
  export interface Params {
    projectId: string;
    podcastId: string;
  }

  export type Response = {
    message: string;
  };
}
